import React, { useState, useEffect } from "react";
import {
  Space,
  Card,
  Layout,
  Form,
  Input,
  Button,
  message,
  Row,
  Col,
  Select,
  Tag,
  List,
  Avatar,
} from "antd";
import {
  CreditCardOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import SideBar from "./_sideBar";
import CopyRight from "./CopyRight";
import axios from "axios";
import moment from "moment";

const TransactionManagement = () => {
  const { Content } = Layout;
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [nextMenuDisabled, setNextMenuDisabled] = useState(false);
  const [form] = Form.useForm();
  const [bankReferenceNo, setBankReferenceNo] = useState(null);
  const [bankType, setBankType] = useState(null);
  const [tableData, setTableData] = useState([]); // State for table data
  const [loading, setLoading] = useState(false);
  const [merchant, setMerchant] = useState();
  const [loginUser, setLoginUser] = useState();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));
  const user = JSON.parse(localStorage.getItem("loginUser"));
  useEffect(() => {
    setLoginUser(user);

    getMerchantData();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [form]);

  const getMerchantData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/findAllMerchantAndSubMerchant`,
      {
        headers: {
          Authorization: `Bearer ${loginUserToken}`,
        },
      }
    );
    const data = res.data;

    form.setFieldsValue({
      merchantCode: data[0]?.merchantCode, // You can choose the first merchant or provide a default
    });

    setMerchant(data.flatMap((m) => m.merchant));
  };

  // Submit handler for the form
  const onFinish = async (values) => {
    try {
      setLoading(true);

      // Send POST request to the backend
      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/enquiry/findTransactionByInvoiceNo`,
        null, // No body for the POST request
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
          params: {
            merchantCode: values.merchantCode, // Query parameters go here
            invoiceNo: values.invoiceNo,
          },
        }
      );

      // Update table data with response
      setTableData([response.data]);
      setBankReferenceNo("");
      // setTableData((prevData) => [...prevData, response.data]);
      // message.success("Transaction added successfully!");
      form.resetFields(); // Reset form after successful submission
    } catch (error) {
      console.error("Error submitting data:", error);
      message.error("Failed to submit transaction.");
    } finally {
      setLoading(false);
    }
  };

  const handleQueryOrder = async (
    merchantCode,
    invoiceNo,
    bankType,
    bankReferenceNo
  ) => {
    console.log(bankType, merchantCode, invoiceNo);
    try {
      let response;
      if (bankType === "KBZ_PAY") {
        response = await axios.post(
          `${process.env.REACT_APP_API_BACKEND_URL}/v1/kbzpay/queryOrder`,
          null, // No body for the POST request
          {
            headers: {
              Authorization: `Bearer ${loginUserToken}`,
            },
            params: {
              merchantCode,
              invoiceNo,
            },
          }
        );

        console.log("KBZ RESP ", response);
        if (
          response.data.code === "0" &&
          response.data.result === "SUCCESS" &&
          response.data.trade_status === "PAY_SUCCESS"
        ) {
          // Update the specific item's status in tableData
          setTableData((prevData) =>
            prevData.map((item) =>
              item.invoiceNo === invoiceNo
                ? { ...item, status: "SUCCESS" } // Update status to SUCCESS
                : item
            )
          );

          // Show success message
          message.success(
            "This payment transaction has already been completed successfully."
          );
        } else {
          message.error(
            "This payment transaction has failed. Please try the payment again."
          );
        }
      } else if (bankType === "AYA_PAY") {
        response = await axios.post(
          `${process.env.REACT_APP_API_BACKEND_URL}/v1/ayapay/queryOrder`,
          null, // No body for the POST request
          {
            headers: {
              Authorization: `Bearer ${loginUserToken}`,
            },
            params: {
              merchantCode,
              invoiceNo,
              bankReferenceNo,
            },
          }
        );
        if (response.data.err === 200 && response.data.message === "Success") {
          setTableData((prevData) =>
            prevData.map((item) =>
              item.invoiceNo === invoiceNo
                ? { ...item, status: "SUCCESS" } // Update status to SUCCESS
                : item
            )
          );

          // Show success message
          message.success(
            "This payment transaction has already been completed successfully."
          );
        } else {
          message.error(
            "This payment transaction has failed. Please try the payment again."
          );
        }
      } else if (bankType === "OK_Dollar") {
        response = await axios.post(
          `${process.env.REACT_APP_API_BACKEND_URL}/v1/okdollar/queryOrder`,
          null, // No body for the POST request
          {
            headers: {
              Authorization: `Bearer ${loginUserToken}`,
            },
            params: {
              merchantCode,
              invoiceNo,
              bankReferenceNo,
            },
          }
        );

        console.log("KBZ RESP ", response);

        if (
          response.data.Code === "200" &&
          response.data.Msg === "Payment Success"
        ) {
          // Update the specific item's status in tableData
          setTableData((prevData) =>
            prevData.map((item) =>
              item.invoiceNo === invoiceNo
                ? { ...item, status: "SUCCESS" } // Update status to SUCCESS
                : item
            )
          );

          // Show success message
          message.success(
            "This payment transaction has already been completed successfully."
          );
        } else {
          message.error(
            "This payment transaction has failed. Please try the payment again."
          );
        }
      }
    } catch (error) {
      console.error("Error querying order:", error);
      message.error("Error occurred while querying order.");
    }
  };

  const banks = [
    {
      bankType: "KBZ_PAY",
      bankName: "KBZ",
    },
    {
      bankType: "AYA_PAY",
      bankName: "AYA",
    },
    {
      bankType: "CB_PAY",
      bankName: "CB",
    },
    {
      bankType: "OK_Dollar",
      bankName: "OK$",
    },
  ];

  const handleBankChange = (value) => {
    setBankType(value);
  };

  const handleBankReferenceChange = (value) => {
    setBankReferenceNo(value);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SideBar
        menuDisabled={menuDisabled}
        nextMenuDisabled={nextMenuDisabled}
        fontSize="14px"
        drawerVisibleValue={drawerVisible}
        setDrawerVisibleValue={setDrawerVisible}
      />

      <Layout className="site-layout">
        <Content>
          <div className="site-layout-background" style={{ minHeight: 360 }}>
            <Space
              direction="vertical"
              style={{ padding: "10px", width: "100%" }}
            >
              <Card
                title={
                  <span>
                    {isMobile && (
                      <MenuOutlined
                        onClick={() => setDrawerVisible((prev) => !prev)}
                        style={{ marginRight: 8, fontSize: 30 }}
                      />
                    )}
                    <CreditCardOutlined style={{ marginRight: 8 }} />
                    Transaction Management
                  </span>
                }
                headStyle={{ backgroundColor: "#cccccc" }}
                extra={
                  <span>
                    {loginUser?.username}
                    <Avatar
                      src={loginUser?.avatarUrl}
                      icon={!loginUser?.avatarUrl && <UserOutlined />}
                      style={{ marginLeft: 8 }}
                    />
                  </span>
                }
              >
                {/* Ant Design Form */}
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                  }}
                >
                  <Row gutter={16}>
                    {/* Bank Name */}
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="bankType"
                        label="Bank Name"
                        rules={[
                          {
                            required: true,
                            message: "Please select bank!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Bank"
                          allowClear
                          onChange={(value) => {
                            form.setFieldsValue({ bankType: value });
                            handleBankChange(value);
                          }}
                        >
                          {banks.map((s) => (
                            <Select.Option key={s.bankType} value={s.bankType}>
                              {s.bankName}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    {/* Merchant Name */}
                    <Col xs={24} sm={12}>
                      <Form.Item name="merchantCode" hidden>
                        <Input type="hidden" />
                      </Form.Item>
                      <Form.Item
                        label="Merchant"
                        name="merchantCode"
                        rules={[
                          {
                            required: true,
                            message: "Please select merchant!",
                          },
                        ]}
                      >
                        <Select placeholder="Select Merchant Name" allowClear>
                          {merchant?.map((s) => (
                            <Select.Option
                              key={s.merchantCode}
                              value={s.merchantCode}
                            >
                              {s.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    {/* Invoice Number */}
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Invoice Number/Order ID"
                        name="invoiceNo"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Invoice No.!",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Invoice No." />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Card>

              {tableData.length > 0 ? (
                <List
                  bordered
                  dataSource={tableData}
                  renderItem={(item) => (
                    <List.Item>
                      <div style={{ width: "100%" }}>
                        <h4>Invoice No: {item.invoiceNo}</h4>
                        <p>
                          <strong>Date/Time:</strong>{" "}
                          {moment(item.dateTime).format("DD/MM/YYYY HH:mm:ss")}
                        </p>
                        <p>
                          <strong>Merchant Name:</strong> {item.merchantCode}
                        </p>
                        <p>
                          <strong>SubMerchant Name:</strong>{" "}
                          {item.subMerchantCode}
                        </p>
                        <p>
                          <strong>Transaction Amount:</strong> MMK{" "}
                          {item.amount.toLocaleString()}
                        </p>
                        <p>
                          <strong>Product Description:</strong>{" "}
                          {item.description}
                        </p>
                        <p>
                          <strong>Status:</strong>{" "}
                          <Tag
                            color={
                              item.status === "SUCCESS" ? "green" : "orange"
                            }
                          >
                            {item.status}
                          </Tag>
                        </p>

                        {item.status === "SUCCESS" ? (
                          ""
                        ) : (
                          <>
                            {(bankType === "AYA_PAY" ||
                              bankType === "OK_Dollar") && (
                              <Form.Item
                                label="Bank Reference No"
                                name="bankReferenceNo"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter bank reference No.!",
                                  },
                                ]}
                              >
                                <Input
                                  value={bankReferenceNo || ""}
                                  style={{ width: "auto" }}
                                  onChange={(e) =>
                                    handleBankReferenceChange(e.target.value)
                                  }
                                  placeholder="Enter bank referenceNo"
                                />
                              </Form.Item>
                            )}
                            <Button
                              htmlType="button"
                              type="primary"
                              style={{
                                marginTop: "8px",
                              }}
                              onClick={() => {
                                handleQueryOrder(
                                  item.merchantCode,
                                  item.invoiceNo,
                                  bankType,
                                  bankReferenceNo
                                );
                              }}
                            >
                              Check
                            </Button>
                          </>
                        )}
                      </div>
                    </List.Item>
                  )}
                />
              ) : (
                <p>No data available</p>
              )}
            </Space>
          </div>
          <CopyRight />
        </Content>
      </Layout>
    </Layout>
  );
};

export default TransactionManagement;
